module.exports = __webpack_public_path__ + "img/visasmall.ac9efeeb.png";